"use client"

import { useState } from "react"

function Circular() {

  return (
    <section className="py-12 bg-newblue/10" id = 'circular'>
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center max-w-md mx-auto">
          <h2 className="text-2xl font-bold tracking-tight mb-2">See our Circular</h2>
          <p className="text-gray-500 mb-6">Visit to see our weekly deals, recipes, and updates from Food Universe!</p>
         <button
              onClick= {() => {window.open("https://fooduniverse.keyfood.com/store/foodUniverse/en/circular-pdf", "_blank", "noopener,noreferrer")}}
              type="submit"
              className="bg-blue-600/90 hover:bg-blue-900 text-white px-4 py-2 rounded-md font-medium transition-colors"
            >
              Click here!
            </button>
        </div>
      </div>
    </section>
  )
}

export default Circular
